<template>
  <TransitionRoot appear :show="isOpen" as="template">
    <Dialog
      as="div"
      :open="isOpen"
      class="relative z-[999]"
      @close="isOpen = false"
    >
      <TransitionChild
        as="template"
        enter="duration-300 ease-out"
        enter-from="opacity-0"
        enter-to="opacity-100"
        leave="duration-200 ease-in"
        leave-from="opacity-100"
        leave-to="opacity-0"
      >
        <div class="fixed inset-0 bg-black bg-opacity-50" />
      </TransitionChild>

      <div
        class="fixed inset-0 flex h-full w-full items-center justify-center p-4"
      >
        <TransitionChild
          as="template"
          enter="duration-300 ease-out"
          enter-from="opacity-0 scale-95"
          enter-to="opacity-100 scale-100"
          leave="duration-200 ease-in"
          leave-from="opacity-100 scale-100"
          leave-to="opacity-0 scale-95"
        >
          <DialogPanel
            class="flex h-auto max-h-full w-[818px] flex-col bg-white pt-5 pb-10 shadow-xl transition-all md:pt-10 md:pb-16"
          >
            <div class="flex px-4 md:px-11">
              <UiButton
                variant="clear"
                variant-type="icon"
                class="ml-auto"
                @click="isOpen = false"
              >
                <UiIcon name="close" class="h-6 w-6 text-gray-elements" />
              </UiButton>
            </div>
            <DialogTitle
              class="mb-6 px-4 text-center text-2xl font-medium md:-mt-4 md:px-11 md:text-3xl"
            >
              Thank you for the review!
            </DialogTitle>

            <div class="px-4 text-center md:px-11">
              <p class="text-sm font-normal md:text-base">
                Your comments will be available soon.
              </p>
              <UiButton
                color="primary"
                class="mt-10 w-full max-w-[268px] font-medium md:mt-16"
                @click="isOpen = false"
              >
                Back to shopping
              </UiButton>
            </div>
          </DialogPanel>
        </TransitionChild>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script setup lang="ts">
import {
  Dialog,
  DialogPanel,
  TransitionRoot,
  TransitionChild,
  DialogTitle,
} from "@headlessui/vue";

const props = defineProps<{
  modelValue: boolean;
}>();

const emit = defineEmits(["update:modelValue"]);

const isOpen = computed<boolean>({
  set(val) {
    emit("update:modelValue", val);
  },
  get() {
    return props.modelValue;
  },
});
</script>
